module.exports = __webpack_public_path__ + "img/12_4.f146d115.png";